import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M18.5921 0L29.0647 10.6662V28.2662C29.0647 30.3286 27.4241 32 25.3993 32H6.54841C4.52361 32 2.88281 30.3272 2.88281 28.2662V3.73376C2.88297 1.67136 4.52377 0 6.54857 0H18.5921Z",
      fill: "#5895FF"
    }, null, -1),
    _createElementVNode("path", {
      d: "M29.0647 10.6662H22.4423C20.4189 10.6662 18.592 8.8072 18.592 6.74464V0L29.0647 10.6662Z",
      fill: "white",
      "fill-opacity": "0.4"
    }, null, -1),
    _createElementVNode("path", {
      d: "M13.3555 22.6663V24H8.11914V22.6663H13.3555ZM18.5919 20V21.3338H8.11914V20H18.5919ZM18.5919 17.3338V18.6663H8.11914V17.3338H18.5919ZM18.5919 14.6663V16H8.11914V14.6663H18.5919Z",
      fill: "white"
    }, null, -1)
  ])))
}
export default { render: render }